import React from 'react';

import classNames from 'classnames';

import { ErrorBoundary } from '@nxte-nl/error-boundary';

import { FooterContainer } from '../../containers/FooterContainer/FooterContainer';
import {
  GoogleClickIdContainer,
} from '../../containers/GoogleClickIdContainer/GoogleClickIdContainer';
import { HeaderContainer } from '../../containers/HeaderContainer/HeaderContainer';
import { Props as LayoutContainerProps } from '../../containers/LayoutContainer/LayoutContainer';
import {
  StoreSwitcherModalContainer,
} from '../../containers/StoreSwitcherModalContainer/StoreSwitcherModalContainer';
import { LoadingWrapper } from '../LoadingWrapper/LoadingWrapper';
import { ScrollUpButton } from '../ScrollUpButton/ScrollUpButton';
import styles from './Layout.module.css';

export type Props = LayoutContainerProps & {
  loading?: boolean;
};

export const Layout = React.memo(({
  children,
  loading = false,

  loadingWrapperClassName,
  contentClassName,
  contentInnerClassName,
  stretchInnerContentWithFooterBottomPartToFullScreen = true,
  stretchInnerContentWithoutFooterToFullScreen = false,

  withHeader = true,
  withFooter = true,

  headerProps = {},
  footerProps = {},
}: Props) => {
  return (
    <>
      <GoogleClickIdContainer />

      <div className={styles.layout}>
        <ErrorBoundary>
          {withHeader && <HeaderContainer loading={loading} {...headerProps} />}
        </ErrorBoundary>

        <StoreSwitcherModalContainer />

        <LoadingWrapper
          loading={loading}
          className={classNames(loadingWrapperClassName, {
            [styles.fullScreen]: stretchInnerContentWithFooterBottomPartToFullScreen
              || stretchInnerContentWithoutFooterToFullScreen,
          })}
          loadingBarFixedAtTheCenterOfTheScreen={true}
        >
          <div
            className={classNames(styles.content, {
              [styles.visible]: !loading,
              [styles.invisible]: loading,
              [styles.fullScreen]: stretchInnerContentWithFooterBottomPartToFullScreen
                || stretchInnerContentWithoutFooterToFullScreen,
            })}
          >
            <div className={classNames(styles.bottomWrapper, contentInnerClassName, {
              [styles.undisplayed]: loading,
              [styles.fullScreen]: stretchInnerContentWithoutFooterToFullScreen,
              [styles.fullScreenInner]: stretchInnerContentWithFooterBottomPartToFullScreen,
            })}>
              <div className={classNames(styles.verticallyStretched, contentClassName)}>
                <ErrorBoundary>
                  {children}
                </ErrorBoundary>
              </div>

              <ErrorBoundary>
                {!loading && children && withFooter && <FooterContainer {...footerProps} />}
              </ErrorBoundary>
            </div>
            <ScrollUpButton />
          </div>
        </LoadingWrapper>
      </div>
    </>
  );
});

Layout.displayName = 'Layout';
